import { DropDownButton } from "@tql/ui-components-react/tql/buttons";
import { dotsVertical } from "@tql/ui-components-react/untitled/icons";
import type { ReactElement } from "react";
import { cloneElement, memo } from "react";

// A fully-resolved menu row: `disabled` and `dividerBefore` are already computed
// by the caller so this component stays purely presentational.
export type DropdownMenuItem = {
	label: string;
	onClick: () => void;
	disabled: boolean;
	dividerBefore: boolean;
};

/**
 * The header "kebab" menu. Wraps the Kendo `DropDownButton` render plumbing
 * (item/itemRender/onItemClick) so the layout only has to hand it a list of
 * resolved menu items.
 */
export const ShipmentActionsMenu = memo(
	({ items }: { items: DropdownMenuItem[] }) => (
		<DropDownButton
			className={"header-action-button"}
			item={(itemProps: { item: DropdownMenuItem; itemIndex: number }) => (
				<span
					className={
						itemProps.item.disabled
							? "k-menu-link-text k-disabled"
							: "k-menu-link-text"
					}
				>
					{itemProps.item.label}
				</span>
			)}
			itemRender={(
				li: ReactElement<{ className?: string }>,
				itemProps: { dataItem?: DropdownMenuItem },
			) =>
				cloneElement(li, {
					className: itemProps.dataItem?.dividerBefore
						? `${li.props.className ?? ""} dropdown-divider`
						: li.props.className,
				})
			}
			items={items}
			onItemClick={(event: { item: DropdownMenuItem }) => {
				if (event.item.disabled) {
					return;
				}
				event.item.onClick();
			}}
			svgIcon={dotsVertical}
		/>
	),
);

ShipmentActionsMenu.displayName = "ShipmentActionsMenu";
